import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

const ErrorMessage = (props: any) => {
	return (
		<Dialog
			open={props.openModalError}
			onClose={props.handleCloseModal}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			style={{
				backdropFilter: 'blur(3px)',
				background: 'transparent',
			}}
			sx={{
				'& .MuiPaper-root': {
					borderRadius: '17px',
					width: '414px',
					height: 'auto',
				},
			}}
		>
			<DialogTitle
				style={{
					color: '#003C82',
					fontWeight: 'bold',
					fontFamily: 'Montserrat',
					fontSize: 18,
					borderBottom: '0.5px solid rgb(0 0 0 / 4%)',
					padding: '16px 34px',
				}}
				id="alert-dialog-title"
			>
				Lo sentimos
			</DialogTitle>

			<p
				style={{
					color: '#686868',
					fontFamily: 'Montserrat',
					fontSize: 18,
					padding: '0px 34px',
					marginBottom: '10px',
				}}
			>
				{typeof props.openModalError === 'string'
					? 'El grupo empresarial tiene varios nit'
					: 'En este momento no pudimos procesar tu solicitud.'}
			</p>
			<DialogActions>
				<Button
					style={{
						background: '#0D66B6',
						fontFamily: 'Montserrat',
						color: 'white',
						padding: '8px 26px',
						fontSize: 12,
						borderRadius: 10,
						boxShadow: ' 0px 3px 10px #00000029',
						marginRight: 25,
						marginBottom: 10,
					}}
					onClick={props.handleCloseModal}
				>
					INTENTAR DE NUEVO
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default ErrorMessage;
